import React from "react";
import { Table } from "react-bootstrap";
import { ChartLine, FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import LoadingPage from "./LoadingPage";
import PageSeven from "./PageSeven";

const PageSix = () => {
    require("../Pemetaan.css");
    return (
        <div>
            <div className="report-page">
                <div className="header-second-page">
                    <GridInline width={"100%"}>
                        <GridInline width={"80%"}>
                            <LabelTitle label={"Hasil Asesmen Diagnostik"} size={22} bolder={700} color={"#fff"} />
                            <LabelTitle label={"Nama Sekolah"} size={18} bolder={500} color={"#fff"} />
                        </GridInline>

                        <GridInline width={"20%"}>
                            <div
                                style={{
                                    border: "2px solid #fff",
                                    padding: 5,
                                    textAlign: "center",
                                    borderRadius: 10,
                                }}
                            >
                                <LabelTitle label={"SEKOLAH"} size={20} bolder={700} color={"#fff"} />
                            </div>
                        </GridInline>
                    </GridInline>
                </div>
                <Gap height={20} />
                <div className="section-three">
                    <div className="result">
                        <LabelTitle label={"Progression Survei Karakter"} size={18} bolder={500} color={"#212529"} />
                        <LabelTitle label={"Profil Pelajar Pancasila"} size={14} bolder={400} color={"#212529"} />
                        <Gap height={20} />
                        <div className="rekap-table">
                            <GridInline width={"33%"}>
                                <ChartLine />
                            </GridInline>
                            <GridInline width={"33%"}>
                                <ChartLine />
                            </GridInline>
                            <GridInline width={"33%"}>
                                <ChartLine />
                            </GridInline>
                            <GridInline width={"33%"}>
                                <ChartLine />
                            </GridInline>
                            <GridInline width={"33%"}>
                                <ChartLine />
                            </GridInline>
                            <GridInline width={"33%"}>
                                <ChartLine />
                            </GridInline>
                        </div>
                    </div>
                </div>
                {/* <Gap height={40} />
                <div className="reportFooter">
                    <FooterReport color={"#1D3557"} date={"20/02/2022"} />
                </div> */}
            </div>

            {/* {openPage ? <PageSeven /> : <LoadingPage />} */}
        </div>
    );
};

export default PageSix;
